import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WmIconModule } from '../icon/index';
import { WmButtonModule } from '../button/index';
import { InputComponent } from './input.component';

@NgModule({
	declarations: [InputComponent],
	imports: [CommonModule, WmIconModule, WmButtonModule, FormsModule],
	exports: [InputComponent]
})
export class WmInputModule {}
